<template>
  <v-navigation-drawer
    color="transparent"
    fixed
    permanent
    scrollable
    clipped
    floating
    app
    dense
    :width="240"
  >
    <div class="fixed-image">
      <img src="@/assets/images/sabira_logo_full.svg" />
    </div>
    <v-text-field
      dense
      prepend-inner-icon="mdi-magnify"
      clearable
      @click:clear="clearSearch"
      placeholder="Pretraga"
      outlined
      hide-details
      class="fixed-filter pb-4"
      v-model="searchQuery"
    ></v-text-field>
    <div style="height:70vh;overflow:scroll;margin-top:11.5rem;">
      <v-list nav rounded>
        <v-list-item
          v-for="(nav, index) in filteredNavigationItems"
          :to="nav.route"
          :key="'nav_' + index"
          class="mb-0"
          @click="scrollToTop"
        >
          <div
            style="display:grid;align-items:center;border-radius: 50%;justify-items:center;"
            class="pa-2 primary mr-2"
          >
            <sabira_icon
              :strokewidth="3"
              :icon="nav.icon"
              fill="#fff"
              :width="18"
              :height="18"
            />
          </div>
          <v-list-item-content>
            <v-list-item-title
              style="font-family: 'Open Sans'; font-weight: 500;"
              >{{ nav.name }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
  export default {
    components: {
      sabira_icon: () => import("@/components/sabira_icon"),
    },
    data() {
      return {
        navigation: null,
        searchQuery: "",
        items: [
          {
            route: "/start",
            name: "Start",
            icon: "chart",
          },
          {
            route: "/artikli",
            name: "Artikli",
            icon: "product",
          },
          {
            route: "/klijenti",
            name: "Klijenti",
            icon: "client",
          },
          {
            route: "/dobavljaci",
            name: "Dobavljači",
            icon: "supplier",
          },
          {
            route: "/narudzbe",
            name: "Narudžbe",
            icon: "order",
          },
          {
            route: "/zalihe",
            name: "Zalihe",
            icon: "stock",
          },
          {
            route: "/fakture",
            name: "Fakture",
            icon: "invoice",
          },
          {
            route: "/ponude",
            name: "Ponude",
            icon: "offer",
          },
          {
            route: "/ugovori",
            name: "Ugovori",
            icon: "contract",
          },
          {
            route: "/nalozi",
            name: "Nalozi",
            icon: "work_order",
          },
          {
            route: "/sredstva",
            name: "Sredstva",
            icon: "asset",
          },
          {
            route: "/hr",
            name: "HR",
            icon: "hr",
          },
          {
            route: "/biljeske",
            name: "Bilješke",
            icon: "todo",
          },
          {
            route: "/kalendar",
            name: "Kalendar",
            icon: "calendar",
          },
          {
            route: "/accounts",
            name: "Firme",
            icon: "account",
            restricted: true,
          },
          {
            route: "/users",
            name: "Korisnici",
            icon: "user",
            restricted: true,
          },
          {
            route: "/podrska",
            name: "Podrška",
            icon: "customer-support",
            restricted: true,
          },
        ],
      };
    },
    computed: {
      navigation_items() {
        if (this.$store.getters.user.id !== 1) {
          return this.items.filter((x) => x.restricted !== true);
        } else {
          return this.items;
        }
      },
      filteredNavigationItems() {
        return this.navigation_items.filter((nav) => {
          return nav.name
            .toLowerCase()
            .includes((this.searchQuery || "").toLowerCase());
        });
      },
    },
    methods: {
      get_image_background(image) {
        return (
          "width: 100%;height:100%;background-image: url('" +
          image +
          "');background-size: contain;background-position:center;"
        );
      },
      clearSearch() {
        // Clear the search query when the clear button is clicked
        this.searchQuery = "";
      },
      scrollToTop() {
        window.scrollTo(0, 0);
      },
      get_avatar_initials() {
        let str = this.$store.getters.user.name;
        let initials = str
          .split(/\s/)
          .reduce((response, word) => (response += word.slice(0, 1)), "");
        return initials.toUpperCase();
      },
      get_username() {
        this.$store.getters.user.username !== null
          ? this.$store.getters.user.username
          : "";
      },
    },
  };
</script>
<style scoped>
  .container {
    display: flex;
    justify-content: left;
    align-items: left;
  }
  .fixed-image {
    position: fixed;
    top: 20px;
    left: 5rem;
    width: 30%;
    background: transparent;
    z-index: 1;
  }
  .fixed-filter {
    margin-top: 2rem;
    position: fixed;
    top: 100px;
    z-index: 1;
    margin-left: 0.5rem;
    width: 93%;
  }
</style>
